export { default } from './TabBuyBox';